import React, { useEffect, useState, useRef, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import {openGameModal} from '../../modal/modal_game';
import ModalLogin from '../../modal/modal_login.js';
import Game from '../../../../class/Game/Game';

const SearchResult = React.memo(({ searchResults, loading, game_count,getProviderIcon, isLogged, AuthService, setIsLoginModalOpen }) => {
  const {t} = useTranslation();

  const [localResults, setLocalResults] = useState(searchResults);

  useEffect(() => {
    setLocalResults(searchResults);
  }, [searchResults]);
  

  const updateFavoriteGame = async (newGameId ) => {
      if (isLogged) {
          try {
              // Получаем инфу об игре
              const gameInfo = await Game.getGameInfo(newGameId);
              const gameType = gameInfo?.data?.category_slug || '';

              const user_id = await AuthService.getCustom('user_id');
              const lastGames = await Game.updateFavoriteGames(user_id, gameType, newGameId );
              
              // console.log("NUOVO GIOCO PREFERITO");

          } catch (error) {
              console.error('Failed to fetch game info or open game:', error);
          }
      } else if (!isLogged) {
          setIsLoginModalOpen(true);
          console.error(t('User_is_not_logged_in.'));
      }

      // console.log('ModalGame opened with gameId:', [newGameId, isLogged]);
  };
  
  return (
    <>
      <div className="body main-layout-item ColumnSection_list">
        <div className="Home_root">
          <div className="Home_games">
            <div className="Home_header">
              <div className="HomeSection_header">
                <div className="HomeSection_label">Reusult:</div>
                <div className="HomeSection_right">
                  <div className="HomeSection_caption">Trovati</div>
                  <div className="HomeSection_caption">
                    <strong>{game_count} Game</strong>
                  </div>
                </div>
              </div>
            </div>
            <div className="HomeSectionCasinoGames_list">
              {localResults.map((game, index) => (
                <div
                  className="HomeSectionCasinoGames_game"
                  key={game.id || index} // Уникнення конфліктів із ключами
                
                
                  
                >
                  <div className="CasinoGameCard_root">
                    <div className="CasinoGamePreview_root">
                      <img
                        className="ResponsivePicture_img CasinoGamePreview_image"
                        src={game.thumbnail}
                        alt={game.name}
                        loading="lazy"
                      />
                    </div>
                    <div className="CasinoGameCard_info CasinoGameCard_withProvider">
                      <div className="CasinoGameCard_provider">
                        <img
                          alt={game.provider}
                          src={getProviderIcon(game.provider_slug)}
                          className="CasinoGameCard_icon"
                          onClick={() => openGameModal(game.id)}
                        />
                        <p className="CasinoGameCard_name"onClick={() => openGameModal(game.id)}>{game.provider_name}</p>
                        <button style={{zIndex: "100", width: "12%", position: "absolute", height: "12%",left: "80%"}} onClick={
                          () => {
                          if(isLogged){
                              updateFavoriteGame(game.id);
                              setLocalResults(prev =>
                              prev.map(g =>
                                g.id === game.id
                                  ? { ...g, favorite: Number(g.favorite) === 1 ? 0 : 1 }
                                  : g
                                )
                              );
                          } else{
                              setIsLoginModalOpen(true);
                          }
                          }  
                        }>
                          <svg className="" viewBox='0 0 50 50'>
                          <path d="M38.7,8.9c-4.4-2.4-10.2-1.7-13.8,1.6c-3.7-3.3-9.4-4-13.9-1.6C7.2,11,4.8,15,4.8,19.4
                              c0,1.2,0.2,2.5,0.6,3.5c1.9,8.6,18,18.8,18.7,19.2l0.8,0.5l0.8-0.5c0.7-0.4,16.7-10.6,18.6-19c0.4-1.2,0.6-2.4,0.6-3.7 
                              C44.8,15,42.5,11,38.7,8.9z" fill={(Number(game.favorite) == 1) ? "red" : "transparent"} style={{ stroke: "red", strokeWidth: "4px" }}
                          />
                          </svg>

                        </button>
                      </div>
                      <p className="CasinoGameCard_gameName" onClick={() => openGameModal(game.id)}>{game.name}</p>
                    </div>
                  </div>
                </div>
              ))}
              {loading && (
                <div className="content-loader-games">
                  Loading...
                  <div className="loader-games"></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
});

export default SearchResult;
